import {CreateReducer} from '../utils/create_reducer';
import {GET_MODULE_LIST} from "../actions/report_module_action";

const initState = {
    isFetching:true,
    modules:[],
    currentSelectedModule: {}
};

const reportModuleReducer = CreateReducer(initState, {
    [GET_MODULE_LIST](state, action) {
        return {...state,modules:action.payload}
    }
});

export default reportModuleReducer;


// WEBPACK FOOTER //
// ./src/reducers/report_module_reducer.js